/**
 * AWS Amplify Configuration — Cognito User Pool auth.
 *
 * This must be imported before the app renders (in index.jsx).
 * Amplify manages the ID/Access/Refresh tokens automatically,
 * including silent token refresh when the Access Token expires.
 */

import { Amplify } from 'aws-amplify';

const isDev = import.meta.env.VITE_DEVMODE === 'true';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: isDev
        ? import.meta.env.VITE_DEV_COGNITO_POOL_ID
        : import.meta.env.VITE_COGNITO_POOL_ID,
      userPoolClientId: isDev
        ? import.meta.env.VITE_DEV_COGNITO_CLIENT_ID
        : import.meta.env.VITE_COGNITO_CLIENT_ID,
    },
  },
});
